import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAppListing } from "../../../services/api";
import { AppListing } from "../../../types/appListing";

const useAppDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const [app, setApp] = useState<AppListing | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;
    const fetch = async () => {
      const { status, data } = await getAppListing({ slug });
      if (status === 200) {
        setApp(data);
      } else {
        setNotFound(true);
      }
      setLoading(false);
    };
    fetch();
  }, [slug]);

  return { app, loading, notFound };
};

export default useAppDetail;
